'use strict';

import React from 'react';

/**
 * @see http://7428.net/2012/11/house.html
 */
export default function ErrorPage500 (props) {
  return (
    <div className='page-content'>
      <table style={{width: '700px', margin: '50px auto'}}>
        <tr style={{verticalAlign: 'top'}}>
          <td>
            <h1 style={{padding: '0', fontSize: '150px', margin: '0'}}>
              <span style={{color: '#ff7f29'}}>5</span>
              <span style={{color: '#94c133'}}>0</span>
              <span style={{color: '#749b09'}}>0</span>
            </h1>

            <h2 style={{padding: '0'}}>Что-то пошло не так.</h2>

            <p>Приносим извинения за неудобства.</p>
            <p>С уважением, администрация сайта МЛСН.ру</p>
          </td>
          <td style={{verticalAlign: 'center'}}>
            <img style={{width: '300px', marginLeft: '50px'}} src='/static/img/house.jpg' />
          </td>
        </tr>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ui/Pages/Errors/500.jsx